import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
    getResearchReports
} from './researchAPI'

export const getAsxResearchReportsAsync = createAsyncThunk(
    'research/getResearchReports',
    async (payload) => {
        const response = payload === undefined ? await getResearchReports({
            params: {
                type: 'asx',
            }
        }) : payload;
        return response;
    }
);

export const appendAsxResearchReportsAsync = createAsyncThunk(
    'research/appendResearchReports',
    async (payload) => {
        const response = payload === undefined ? await getResearchReports({
            params: {
                type: 'asx',
            }
        }) : payload;
        return response;
    }
);

export const getUnlistedResearchReportsAsync = createAsyncThunk(
    'research/getUnlistedResearchReports',
    async (payload) => {
        const response = payload === undefined ? await getResearchReports({
            params: {
                type: 'unlisted',
            }
        }) : payload;
        return response;
    }
);

export const appendUnlistedResearchReportsAsync = createAsyncThunk(
    'research/appendUnlistedResearchReports',
    async (payload) => {
        const response = payload === undefined ? await getResearchReports({
            params: {
                type: 'unlisted',
            }
        }) : payload;
        return response;
    }
);

const initialState = {
    asx: {
        status: 'idle',
        meta: [],
        results: [],
    },
    unlisted: {
        status: 'idle',
        meta: [],
        results: [],
    },
};

const research = createSlice({
    name: 'research',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getAsxResearchReportsAsync.pending, (state) => {
                state.asx.status = 'loading';
            })
            .addCase(getAsxResearchReportsAsync.fulfilled, (state, {payload}) => {
                state.asx.status = 'attempted';
                state.asx.meta = payload?.meta ?? [];
                state.asx.results = payload?.data ?? [];
            })
            .addCase(getAsxResearchReportsAsync.rejected, (state) => {
                state.asx.results = [];
                state.asx.status = 'attempted';
            })
            .addCase(appendAsxResearchReportsAsync.pending, (state) => {
                state.asx.status = 'loading';
            })
            .addCase(appendAsxResearchReportsAsync.fulfilled, (state, {payload}) => {
                state.asx.status = 'attempted';
                state.asx.meta = payload?.meta ?? [];
                state.asx.results = [...state.asx.results, ...payload?.data ?? []];
            })
            .addCase(appendAsxResearchReportsAsync.rejected, (state) => {
                state.asx.results = [];
                state.asx.status = 'attempted';
            })
            .addCase(getUnlistedResearchReportsAsync.pending, (state) => {
                state.unlisted.status = 'loading';
            })
            .addCase(getUnlistedResearchReportsAsync.fulfilled, (state, {payload}) => {
                state.unlisted.status = 'attempted';
                state.unlisted.meta = payload?.meta ?? [];
                state.unlisted.results = payload?.data ?? [];
            })
            .addCase(getUnlistedResearchReportsAsync.rejected, (state) => {
                state.unlisted.results = [];
                state.unlisted.status = 'attempted';
            })
            .addCase(appendUnlistedResearchReportsAsync.pending, (state) => {
                state.unlisted.status = 'loading';
            })
            .addCase(appendUnlistedResearchReportsAsync.fulfilled, (state, {payload}) => {
                state.unlisted.status = 'attempted';
                state.unlisted.meta = payload?.meta ?? [];
                state.unlisted.results = [...state.unlisted.results, ...payload?.data ?? []];
            })
            .addCase(appendUnlistedResearchReportsAsync.rejected, (state) => {
                state.unlisted.results = [];
                state.unlisted.status = 'attempted';
            });
    },
});

export default research.reducer;

export {
    getResearchReports
}
